import { useContext, useState } from "react";
import { HouseCompetitionData } from "./contextProvider";
import DOMPurify from "dompurify";

const HouseModalContent = ({ activeTab }: { activeTab: number }) => {
  const [activeTabIndex, setActiveTabIndex] = useState(activeTab);
  const { cashAlternativePopupText, detailsText, amenitiesPopupText, hideCashAlternative } =
    useContext(HouseCompetitionData);

  let POPUP_TABS = ["Key Highlights", "Cash Alternative", "Details"];
  if (hideCashAlternative) {
    POPUP_TABS = ["Key Highlights", "Details"];
  }
  const onTabClick = (e: React.MouseEvent<HTMLSpanElement>, index: number) => {
    e.stopPropagation();
    setActiveTabIndex(index);
  };

  const getPopupContent = () => {
    if (hideCashAlternative) {
      switch (activeTabIndex) {
        case 0:
          return amenitiesPopupText;
        case 1:
          return detailsText;
      }
    } else {
      switch (activeTabIndex) {
        case 0:
          return amenitiesPopupText;
        case 1:
          return cashAlternativePopupText;
        case 2:
          return detailsText;
      }
    }
  };

  return (
    <div className={"flex flex-col"}>
      <div className="flex justify-around border-b-2 border-solid border-b-[#00000014]">
        {POPUP_TABS.map((tabTitle, index) => (
          <span
            key={index}
            className={`text-[14px] text-nowrap font-medium self-end px-4 py-2 cursor-pointer ${activeTabIndex === index ? "text-[#FF8200] border-b-2 border-solid border-b-[#FF8200]" : "text-[#696971]"}`}
            onClick={e => onTabClick(e, index)}>
            {tabTitle}
          </span>
        ))}
      </div>
      <div
        className="mt-8 overflow-auto max-h-[465px] h-[420px]"
        style={{ scrollbarGutter: "stable" }}
        dangerouslySetInnerHTML={{
          __html: DOMPurify.sanitize(getPopupContent()),
        }}
      />
    </div>
  );
};

export default HouseModalContent;
